import React, {useState} from 'react';
import {TableRow, TableCell} from "@mui/material";
import ActivityLogDetailViewDialog from "./dialog/activity-log-detail-view.dialog";
import moment from "moment";

const ActivityRowData = ({activity, index}) => {

    const [openActivityLogDetailView, setOpenActivityLogDetailView] = useState(false);
    const [activityId, setActivityId] = useState(null);

    const handleViewActivity = (e, activity) => {
        setActivityId(activity?.activity_id);
        setOpenActivityLogDetailView(true);
    }


    return (
        <>
            <TableRow key={index} sx={{'&:last-child td, &:last-child th': {border: 0}, '& td, & th': {borderBottom: 0}}}>  
                <TableCell component="th" scope="row" sx={{color: "rgba(51, 51, 207, 0.81)", cursor: "pointer"}} 
                    onClick={(e) => handleViewActivity(e, activity)}
                >
                    {activity?.user_email}               
                </TableCell>

                <TableCell align="left" sx={{color: "#58565F"}}>
                    {activity?.user_type}
                </TableCell>

                <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                    {activity?.module}
                </TableCell>

                <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                    {activity?.action}
                </TableCell>

                <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                    {activity?.activity}
                </TableCell>

                <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                    {moment(activity?.timestamp).format("MMMM DD, YYYY HH:mmA")}
                </TableCell>
            </TableRow>

            {openActivityLogDetailView &&
                <ActivityLogDetailViewDialog 
                    activityId={activityId} activity={activity} 
                    openActivityLogDetailView={openActivityLogDetailView} 
                    setOpenActivityLogDetailView={setOpenActivityLogDetailView}
                />
            }
        </>
    )
}

export default ActivityRowData